import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock, ListChecks, ArrowRight, Trophy } from "lucide-react";

export default function Quizzes() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/quizzes").then(r => setItems(r.data.items)); }, []);

    return (
        <div className="space-y-6" data-testid="quizzes-page">
            <div>
                <div className="text-xs uppercase tracking-widest font-bold text-muted-foreground">Test yourself</div>
                <h1 className="font-display text-3xl lg:text-4xl mt-1">Quizzes</h1>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
                {items.map(q => (
                    <Card key={q.id} className="mx-card" data-testid={`quiz-card-${q.id}`}>
                        <CardContent className="p-5">
                            <div className="flex items-start gap-3">
                                <div className="h-11 w-11 rounded-xl bg-amber-gradient flex items-center justify-center text-white shadow-mx-md">
                                    <ListChecks className="h-5 w-5" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">{q.course_title}</div>
                                    <div className="font-bold text-base mt-1">{q.title}</div>
                                    <div className="flex flex-wrap gap-2 mt-2.5">
                                        <Badge variant="outline" className="text-[10px]"><Clock className="h-3 w-3 mr-1" /> {Math.round(q.time_limit_seconds / 60)} min</Badge>
                                        <Badge variant="outline" className="text-[10px]">Pass {q.pass_percentage}%</Badge>
                                        {q.is_final && <Badge className="bg-[#FFA81B] hover:bg-[#FFA81B] text-[10px]">Final</Badge>}
                                        {q.my_best != null && <Badge className="bg-[#16A34A] hover:bg-[#16A34A] text-[10px]"><Trophy className="h-3 w-3 mr-1" /> Best {q.my_best}%</Badge>}
                                    </div>
                                </div>
                            </div>
                            <Link to={`/student/quizzes/${q.id}/take`}>
                                <Button className="mx-btn-primary mt-4 w-full" data-testid={`start-quiz-${q.id}`}>Start quiz <ArrowRight className="h-4 w-4 ml-1.5" /></Button>
                            </Link>
                        </CardContent>
                    </Card>
                ))}
                {items.length === 0 && <div className="mx-card p-12 text-center text-muted-foreground col-span-2">No quizzes yet.</div>}
            </div>
        </div>
    );
}
